module.exports = __webpack_public_path__ + "img/eb2d580.jpg";